/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../buttons/icon-button/icon-button.component.ngfactory';
import * as import2 from '../buttons/icon-button/icon-button.component';
import * as import3 from '../order/order-summary-icon/order-summary-icon.component.ngfactory';
import * as import4 from '../order/order-summary-icon/order-summary-icon.component';
import * as import5 from '../order/order.model';
import * as import6 from '../notification/message/message.component.ngfactory';
import * as import7 from '../notification/message/message.component';
import * as import8 from '../notification/notification.service';
import * as import9 from '../buttons/link/link.component.ngfactory';
import * as import10 from '../buttons/link/link.component';
import * as import11 from '../ordering-context/ordering-context-panel/ordering-context-panel.component.ngfactory';
import * as import12 from '../ordering-context/ordering-context-panel/ordering-context-panel.component';
import * as import13 from '../ordering-context/ordering-context.model';
import * as import14 from '../orchestration/responsive.service';
import * as import15 from '../orchestration/navigation.service';
import * as import16 from '../promo/promo-carousel/promo-carousel.component.ngfactory';
import * as import17 from '../promo/promo-carousel/promo-carousel.component';
import * as import18 from '../orchestration/session.model';
import * as import19 from '../identity/identity.model';
import * as import20 from '../orchestration/analytics.service';
import * as import21 from '../page-layout/page-header-image/page-header-image.component.ngfactory';
import * as import22 from '../page-layout/page-header-image/page-header-image.component';
import * as import23 from './order-heading-panel/order-heading-panel.component.ngfactory';
import * as import24 from './order-heading-panel/order-heading-panel.component';
import * as import25 from './feature-button-panel/feature-button-panel.component.ngfactory';
import * as import26 from '@angular/common';
import * as import27 from './feature-button-panel/feature-button-panel.component';
import * as import28 from '../group-order/group-order.model';
import * as import29 from '../deal/deal.model';
import * as import30 from '../orchestration/session.controller';
import * as import31 from '../menu/menu-category-selection-panel/menu-category-selection-panel.component.ngfactory';
import * as import32 from '../menu/menu-category-selection-panel/menu-category-selection-panel.component';
import * as import33 from '../menu/menu.model';
import * as import34 from '../menu/menu-subcategory-anchor-panel/menu-subcategory-anchor-panel.component.ngfactory';
import * as import35 from '../menu/menu-subcategory-anchor-panel/menu-subcategory-anchor-panel.component';
import * as import36 from '../menu/menu-item-selection-panel/menu-item-selection-panel.component.ngfactory';
import * as import37 from '../menu/menu-item-selection-panel/menu-item-selection-panel.component';
import * as import38 from '../ui-elements/chewzie-logo/chewzie-logo.component.ngfactory';
import * as import39 from '../ui-elements/chewzie-logo/chewzie-logo.component';
import * as import40 from '../order/order-edit-panel/order-edit-panel.component.ngfactory';
import * as import41 from '../order/order-edit-panel/order-edit-panel.component';
import * as import42 from '../group-order/group-order-summary-icon/group-order-summary-icon.component.ngfactory';
import * as import43 from '../group-order/group-order-summary-icon/group-order-summary-icon.component';
import * as import44 from '../inputs/selector-control/selector-control.component.ngfactory';
import * as import45 from '../inputs/selector-control/selector-control.component';
import * as import46 from '../order/order-totals-panel/order-totals-panel.component.ngfactory';
import * as import47 from '../order/order-totals-panel/order-totals-panel.component';
import * as import48 from '../buttons/button/button.component.ngfactory';
import * as import49 from '../buttons/button/button.component';
import * as import50 from '../page-layout/page-footer-control.directive';
import * as import51 from './quick-pay-panel/quick-pay-panel.component.ngfactory';
import * as import52 from './quick-pay-panel/quick-pay-panel.component';
import * as import53 from '../payment/payment.model';
import * as import54 from '../legal/legal-panel/legal-panel.component.ngfactory';
import * as import55 from '../legal/legal-panel/legal-panel.component';
import * as import56 from '../page-layout/full-page-layout/full-page-layout.component.ngfactory';
import * as import57 from '../page-layout/full-page-layout/full-page-layout.component';
import * as import58 from '../orchestration/page';
import * as import59 from '../theme/theme.model';
import * as import60 from '../order/order-errors-panel/order-errors-panel.component.ngfactory';
import * as import61 from '../order/order-errors-panel/order-errors-panel.component';
import * as import62 from '../orchestration/responsive.directive';
import * as import63 from '../page-layout/desktop-home-page-layout/desktop-home-page-layout.component.ngfactory';
import * as import64 from '../ui-elements/image/background-image.directive';
import * as import65 from '../ui-elements/image/cached-image.service';
import * as import66 from '../page-layout/desktop-home-page-layout/desktop-home-page-layout.component';
import * as import67 from './ordering-page.component';
import * as import68 from '../ui-elements/loading/loading.service';
import * as import69 from '@fedelta-pos/data-client/auth/auth.service';
import * as import70 from '../schedule/active-schedules-search.model';
import * as import71 from '../promo/promo.model';
const styles_OrderingPageComponent:any[] = ([] as any[]);
export const RenderType_OrderingPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderingPageComponent,
  data: {}
}
);
function View_OrderingPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'slot',
        'navbar-left'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.navigationService.createPage('woa-nav-menu-page',(undefined as any),{alignment: co.PageAlignment.LEFT})) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
    import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{
      type: [
        0,
        'type'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]

    }
    ,{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.MENU;
    const currVal_4:boolean = !co.isLoaded;
    ck(v,1,0,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_OrderingPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-summary-icon',[[
        'slot',
        'navbar-right'
      ]
      ],(null as any),[[
        (null as any),
        'onOrderSummary'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onOrderSummary' === en)) {
        const pd_0:any = ((<any>co.viewOrder()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_OrderSummaryIconComponent_0,import3.RenderType_OrderSummaryIconComponent)),
    import0.ɵdid(180224,(null as any),0,import4.OrderSummaryIconComponent,[
      import5.OrderModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),{onOrderSummary: 'onOrderSummary'})
  ]
  ,(null as any),(null as any));
}
function View_OrderingPageComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_ContentMessageComponent_0,import6.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.ContentMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,5,{links: 1}),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),1,1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.requestReload('failure reload',true,true,false,true)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import9.View_LinkComponent_0,import9.RenderType_LinkComponent)),
      import0.ɵdid(49152,[[
        5,
        4
      ]
      ],0,import10.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = 'woa.error.common.loadFailed';
    ck(v,1,0,currVal_8,currVal_9);
    const currVal_10:any = 'woa.button.order.reload';
    ck(v,5,0,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_ContentMessageComponent_0,import6.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.ContentMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,6,{links: 1}),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),1,1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.orderModel.requestOrderInitiation('ordering page - initiation error retry')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import9.View_LinkComponent_0,import9.RenderType_LinkComponent)),
      import0.ɵdid(49152,[[
        6,
        4
      ]
      ],0,import10.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = co.orderModel.initiationErrorKey;
    const currVal_10:any = co.orderModel.initiationErrorParams;
    ck(v,1,0,currVal_8,currVal_9,currVal_10);
    const currVal_11:any = 'woa.button.common.retry';
    ck(v,5,0,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-ordering-context-panel',[[
        'class',
        'mobile-page-ordering-context'
      ]
    ],(null as any),(null as any),(null as any),import11.View_OrderingContextPanelComponent_0,import11.RenderType_OrderingContextPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import12.OrderingContextPanelComponent,[
      import13.OrderingContextModel,
      import5.OrderModel,
      import14.ResponsiveService,
      import15.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
function View_OrderingPageComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-promo-carousel',[[
        'class',
        'mobile-page-promo-carousel'
      ]
    ],(null as any),[
      [
        (null as any),
        'onOrderDeal'
      ]
      ,
      [
        (null as any),
        'onPromoActioned'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onOrderDeal' === en)) {
        const pd_0:any = ((<any>co.orderDeal($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onPromoActioned' === en)) {
        const pd_1:any = ((<any>co.promoActioned($event.promo,$event.promo.promoCardAction,$event.menuItem)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import16.View_PromoCarouselComponent_0,import16.RenderType_PromoCarouselComponent)),
    import0.ɵdid(770048,(null as any),0,import17.PromoCarouselComponent,[
      import18.SessionModel,
      import19.IdentityModel,
      import20.AnalyticsService,
      import15.NavigationService,
      import0.ElementRef,
      import0.ChangeDetectorRef
    ]
    ,{
      promoteMemberLogin: [
        0,
        'promoteMemberLogin'
      ]
      ,
      deals: [
        1,
        'deals'
      ]
      ,
      promos: [
        2,
        'promos'
      ]
      ,
      morePromotionalCards: [
        3,
        'morePromotionalCards'
      ]
      ,
      showMorePromotionalCardsAsSlide: [
        4,
        'showMorePromotionalCardsAsSlide'
      ]
      ,
      nrVisibleSlides: [
        5,
        'nrVisibleSlides'
      ]
      ,
      autoScrollEnabled: [
        6,
        'autoScrollEnabled'
      ]

    }
    ,{
      onOrderDeal: 'onOrderDeal',
      onPromoActioned: 'onPromoActioned'
    }
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = true;
    const currVal_1:any = co.promotedDeals;
    const currVal_2:any = (co.orderModel.personalOrderStarted? co.triggeredAndUnsuppressedCardPromos: co.promotedCardPromos);
    const currVal_3:any = (co.orderModel.personalOrderStarted? false: co.morePromotionalCards);
    const currVal_4:any = true;
    const currVal_5:any = co.nrVisibleSlides;
    const currVal_6:boolean = !co.sessionModel.noAutoScroll;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  },(null as any));
}
function View_OrderingPageComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-page-header-image',[[
        'class',
        'mobile-page-store-image'
      ]
    ],(null as any),(null as any),(null as any),import21.View_PageHeaderImageComponent_0,import21.RenderType_PageHeaderImageComponent)),
    import0.ɵdid(245760,(null as any),0,import22.PageHeaderImageComponent,[
      import18.SessionModel,
      import13.OrderingContextModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
function View_OrderingPageComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-heading-panel',[[
        'class',
        'mobile-page-order-heading'
      ]
    ],(null as any),(null as any),(null as any),import23.View_OrderHeadingPanelComponent_0,import23.RenderType_OrderHeadingPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import24.OrderHeadingPanelComponent,[
      import13.OrderingContextModel,
      import15.NavigationService
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
function View_OrderingPageComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-feature-button-panel',[[
        'class',
        'mobile-page-feature-buttons'
      ]
      ],(null as any),[[
        (null as any),
        'onOpenGroupOrder'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onOpenGroupOrder' === en)) {
        const pd_0:any = ((<any>co.groupOrderModel.openGroupOrder()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import25.View_FeatureButtonPanelComponent_0,import25.RenderType_FeatureButtonPanelComponent)),
    import0.ɵdid(278528,(null as any),0,import26.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod(['order-view']),
    import0.ɵdid(245760,(null as any),0,import27.FeatureButtonPanelComponent,[
      import18.SessionModel,
      import13.OrderingContextModel,
      import19.IdentityModel,
      import28.GroupOrderModel,
      import29.DealModel,
      import15.NavigationService,
      import30.SessionController,
      import0.ChangeDetectorRef,
      import20.AnalyticsService
    ]
    ,(null as any),{onOpenGroupOrder: 'onOpenGroupOrder'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'mobile-page-feature-buttons';
    const currVal_1:any = ck(v,3,0,import0.ɵunv(v,1,1,import0.ɵnov(v,2).transform(co.viewingOrder$)));
    ck(v,1,0,currVal_0,currVal_1);
    ck(v,4,0);
  },(null as any));
}
function View_OrderingPageComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-menu-category-selection-panel',[[
        'class',
        'mobile-page-menu-categories'
      ]
      ],[[
        2,
        'with-images',
        (null as any)
      ]
    ],(null as any),(null as any),import31.View_MenuCategorySelectionPanelComponent_0,import31.RenderType_MenuCategorySelectionPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import32.MenuCategorySelectionPanelComponent,[
      import33.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).withImages;
    ck(v,0,0,currVal_0);
  });
}
function View_OrderingPageComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,[[
        2,
        0
      ]
      ],(null as any),1,'woa-menu-subcategory-anchor-panel',[[
        'class',
        'mobile-page-menu-subcategory-anchors'
      ]
    ],(null as any),(null as any),(null as any),import34.View_MenuSubcategoryAnchorPanelComponent_0,import34.RenderType_MenuSubcategoryAnchorPanelComponent)),
      import0.ɵdid(4440064,[[
        'anchorPanel',
        4
      ]
    ],0,import35.MenuSubcategoryAnchorPanelComponent,[
      import33.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
function View_OrderingPageComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-menu-item-selection-panel',[[
        'class',
        'mobile-page-menu-items'
      ]
      ],(null as any),[[
        (null as any),
        'onBack'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onBack' === en)) {
        const pd_0:any = ((<any>co.navigationService.dismissView()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import36.View_MenuItemSelectionPanelComponent_0,import36.RenderType_MenuItemSelectionPanelComponent)),
    import0.ɵdid(4440064,(null as any),0,import37.MenuItemSelectionPanelComponent,[
      import33.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,{
      pageScroller: [
        0,
        'pageScroller'
      ]
      ,
      anchorPanel: [
        1,
        'anchorPanel'
      ]

    }
    ,{onBack: 'onBack'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.pageLayout == null)? (null as any): co.pageLayout.scrollerElementRef);
    const currVal_1:any = co.anchorPanelER;
    ck(v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_OrderingPageComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderingPageComponent_13)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderingPageComponent_14)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderingPageComponent_15)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = !import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform(co.viewingMenuItems$));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,7,0,import0.ɵnov(v,8).transform(co.viewingMenuItems$));
    ck(v,7,0,currVal_1);
    const currVal_2:any = import0.ɵunv(v,11,0,import0.ɵnov(v,12).transform(co.viewingMenuItems$));
    ck(v,11,0,currVal_2);
  },(null as any));
}
function View_OrderingPageComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_ContentMessageComponent_0,import6.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.ContentMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,7,{links: 1})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.INFO;
    const currVal_9:any = co.StringUtils.quote(co.sessionModel.currentApp.dietaryStatement);
    ck(v,1,0,currVal_8,currVal_9);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingPageComponent_12)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'mobile-page-footer'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingPageComponent_16)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'mobile-page-footer-logo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-chewzie-logo',([] as any[]),(null as any),(null as any),(null as any),import38.View_ChewzieLogoComponent_0,import38.RenderType_ChewzieLogoComponent)),
    import0.ɵdid(49152,(null as any),0,import39.ChewzieLogoComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.showMenu;
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.isLoaded && co.sessionModel.currentApp.dietaryStatement);
    ck(v,8,0,currVal_1);
  },(null as any));
}
function View_OrderingPageComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-edit-panel',[[
        'class',
        'mobile-page-order'
      ]
    ],(null as any),[
      [
        (null as any),
        'onEditOrderItem'
      ]
      ,
      [
        (null as any),
        'onRemoveOrderItem'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onEditOrderItem' === en)) {
        const pd_0:any = ((<any>co.orderModel.editOrderItem($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onRemoveOrderItem' === en)) {
        const pd_1:any = ((<any>co.orderModel.removeOrderItem($event)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import40.View_OrderEditPanelComponent_0,import40.RenderType_OrderEditPanelComponent)),
    import0.ɵdid(4374528,(null as any),0,import41.OrderEditPanelComponent,[
      import13.OrderingContextModel,
      import5.OrderModel,
      import33.MenuModel,
      import30.SessionController,
      import15.NavigationService,
      import0.ChangeDetectorRef,
      import8.NotificationService,
      import20.AnalyticsService
    ]
      ,{showRetry: [
        0,
        'showRetry'
      ]
    },{
      onEditOrderItem: 'onEditOrderItem',
      onRemoveOrderItem: 'onRemoveOrderItem'
    }
    )
  ]
  ,(ck,v) => {
    const currVal_0:any = false;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingPageComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-footer-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_FooterMessageComponent_0,import6.RenderType_FooterMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.FooterMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      icon: [
        1,
        'icon'
      ]
      ,
      text: [
        2,
        'text'
      ]
      ,
      translationParams: [
        3,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,8,{links: 1}),
    import0.ɵpod([
      'category',
      'venueWaitTime',
      'categoryWaitTime'
    ]
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.WARNING;
    const currVal_9:any = 'clock-three';
    const currVal_10:any = co.waitTimeNotice;
    const currVal_11:any = ck(v,3,0,co.menuModel.getCategoryDisplayName(co.menuModel.selectedCategory),co.orderingContextModel.venueWaitTime,co.menuModel.selectedCategoryWaitTime);
    ck(v,1,0,currVal_8,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-footer-message',[[
        'class',
        'group-order-notice'
      ]
    ],[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.groupOrderModel.openGroupOrder()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import6.View_FooterMessageComponent_0,import6.RenderType_FooterMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.FooterMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      showIcon: [
        2,
        'showIcon'
      ]
      ,
      actionable: [
        3,
        'actionable'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,9,{links: 1}),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'woa-group-order-summary-icon',([] as any[]),(null as any),(null as any),(null as any),import42.View_GroupOrderSummaryIconComponent_0,import42.RenderType_GroupOrderSummaryIconComponent)),
    import0.ɵdid(180224,(null as any),0,import43.GroupOrderSummaryIconComponent,[
      import5.OrderModel,
      import28.GroupOrderModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.SUCCESS;
    const currVal_9:any = 'woa.message.order.groupOrderNotice';
    const currVal_10:any = false;
    const currVal_11:any = true;
    ck(v,1,0,currVal_8,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-selector-control',[
      [
        'class',
        'marketing-opt-in'
      ]
      ,
      [
        'slot',
        'footer-start'
      ]

    ]
    ,[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'touched',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'selectedChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('selectedChange' === en)) {
        const pd_0:any = ((<any>(co.orderingContextModel.marketingOptIn = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import44.View_SelectorControlComponent_0,import44.RenderType_SelectorControlComponent)),
    import0.ɵdid(49152,(null as any),0,import45.SelectorControlComponent,([] as any[]),{
      selected: [
        0,
        'selected'
      ]
      ,
      label: [
        1,
        'label'
      ]

    }
    ,{selectedChange: 'selectedChange'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.orderingContextModel.marketingOptIn;
    const currVal_3:any = 'woa.label.common.marketingOptIn';
    ck(v,1,0,currVal_2,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).touched;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_OrderingPageComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-totals-panel',[
      [
        'class',
        'totals'
      ]
      ,
      [
        'slot',
        'footer-start'
      ]

    ]
    ,(null as any),(null as any),(null as any),import46.View_OrderTotalsPanelComponent_0,import46.RenderType_OrderTotalsPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import47.OrderTotalsPanelComponent,[
      import13.OrderingContextModel,
      import5.OrderModel,
      import15.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
function View_OrderingPageComponent_22(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.viewOrder()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import48.View_ButtonComponent_0,import48.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import49.ButtonComponent,[
      import0.ElementRef,
      import18.SessionModel,
      import0.ChangeDetectorRef,
      import14.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['items']),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import50.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.order.view';
    const currVal_28:any = ck(v,2,0,co.orderModel.totalItems);
    ck(v,1,0,currVal_27,currVal_28);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderingPageComponent_23(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.checkout()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import48.View_ButtonComponent_0,import48.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import49.ButtonComponent,[
      import0.ElementRef,
      import18.SessionModel,
      import0.ChangeDetectorRef,
      import14.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      showSpinner: [
        1,
        'showSpinner'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]
      ,
      prominence: [
        3,
        'prominence'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import50.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = co.otherPayLabel;
    const currVal_28:any = co.checkoutPending;
    const currVal_29:any = (co.checkoutPending || (import0.ɵunv(v,1,2,import0.ɵnov(v,2).transform(co.OrderEvents.orderInitiationStatus$)) === co.OrderInitiationStatus.INITIATING));
    const currVal_30:any = co.otherPayProminence;
    ck(v,1,0,currVal_27,currVal_28,currVal_29,currVal_30);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderingPageComponent_24(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-quick-pay-panel',[[
        'woa-page-footer-control',
        ''
      ]
      ],(null as any),[[
        (null as any),
        'pay'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pay' === en)) {
        const pd_0:any = ((<any>co.quickPay(false,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import51.View_QuickPayPanelComponent_0,import51.RenderType_QuickPayPanelComponent)),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import50.PageFooterControlDirective,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(49152,(null as any),0,import52.QuickPayPanelComponent,[
      import5.OrderModel,
      import53.PaymentModel,
      import18.SessionModel,
      import28.GroupOrderModel
    ]
    ,{
      requireLogin: [
        0,
        'requireLogin'
      ]
      ,
      showSpinner: [
        1,
        'showSpinner'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]

    }
    ,{pay: 'pay'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = false;
    const currVal_1:any = co.checkoutPending;
    const currVal_2:any = co.checkoutPending;
    ck(v,2,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
function View_OrderingPageComponent_25(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-legal-panel',[
      [
        'class',
        'mobile-page-payment-legal'
      ]
      ,
      [
        'slot',
        'footer-end'
      ]

    ]
    ,(null as any),(null as any),(null as any),import54.View_LegalPanelComponent_0,import54.RenderType_LegalPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import55.LegalPanelComponent,[
      import20.AnalyticsService,
      import15.NavigationService
    ]
      ,{messageSet: [
        0,
        'messageSet'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'payment';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),86,'woa-full-page-layout',[[
        'class',
        'mobile-page'
      ]
    ],(null as any),[
      [
        (null as any),
        'onExit'
      ]
      ,
      [
        (null as any),
        'onRefresh'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onExit' === en)) {
        const pd_0:any = ((<any>co.sessionController.confirmExitApp()) !== false);
        ad = (pd_0 && ad);
      }
      if (('onRefresh' === en)) {
        const pd_1:any = ((<any>co.requestReload('user refresh',true,true,true,true)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import56.View_FullPageLayoutComponent_0,import56.RenderType_FullPageLayoutComponent)),
    import0.ɵdid(278528,(null as any),0,import26.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod(['order-view']),
    import0.ɵdid(114688,(null as any),1,import57.FullPageLayoutComponent,[
      import58.Page,
      import15.NavigationService,
      import14.ResponsiveService,
      import59.ThemeModel
    ]
    ,{
      showNavbarLogo: [
        0,
        'showNavbarLogo'
      ]
      ,
      hideBackButton: [
        1,
        'hideBackButton'
      ]
      ,
      enableSwipeRefresh: [
        2,
        'enableSwipeRefresh'
      ]
      ,
      showExitButton: [
        3,
        'showExitButton'
      ]
      ,
      navbarTitle: [
        4,
        'navbarTitle'
      ]
      ,
      translationParams: [
        5,
        'translationParams'
      ]
      ,
      pillarboxedOnMobile: [
        6,
        'pillarboxedOnMobile'
      ]
      ,
      showFooter: [
        7,
        'showFooter'
      ]

    }
    ,{
      onRefresh: 'onRefresh',
      onExit: 'onExit'
    }
    ),
    import0.ɵqud(603979776,4,{footerControls: 1}),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod(['categoryName']),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import58.PageLayout,(null as any),[import57.FullPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderingPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),1,1,'woa-icon-button',[[
        'slot',
        'navbar-right'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.searchMenu()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
    import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{
      type: [
        0,
        'type'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]
      ,
      enlarged: [
        2,
        'enlarged'
      ]

    }
    ,{onActivate: 'onActivate'}),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),1,1,(null as any),View_OrderingPageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),2,1,(null as any),View_OrderingPageComponent_4)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),2,3,(null as any),View_OrderingPageComponent_5)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingPageComponent_6)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingPageComponent_7)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingPageComponent_8)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,2,(null as any),View_OrderingPageComponent_9)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingPageComponent_10)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,2,(null as any),View_OrderingPageComponent_11)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,2,(null as any),View_OrderingPageComponent_17)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),6,1,'woa-order-errors-panel',[[
        'slot',
        'footer-messages'
      ]
    ],(null as any),(null as any),(null as any),import60.View_OrderErrorsPanelComponent_0,import60.RenderType_OrderErrorsPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import61.OrderErrorsPanelComponent,[
      import5.OrderModel,
      import13.OrderingContextModel,
      import18.SessionModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),6,1,(null as any),View_OrderingPageComponent_18)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),6,1,(null as any),View_OrderingPageComponent_19)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,2,(null as any),View_OrderingPageComponent_20)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,2,(null as any),View_OrderingPageComponent_21)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,2,(null as any),View_OrderingPageComponent_22)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,2,(null as any),View_OrderingPageComponent_23)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,2,(null as any),View_OrderingPageComponent_24)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),9,2,(null as any),View_OrderingPageComponent_25)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'mobile-page';
    const currVal_1:any = ck(v,3,0,import0.ɵunv(v,1,1,import0.ɵnov(v,2).transform(co.viewingOrder$)));
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = (import0.ɵunv(v,4,0,import0.ɵnov(v,6).transform(co.viewingOrder$)) || !import0.ɵunv(v,4,0,import0.ɵnov(v,7).transform(co.viewingMenuItems$)));
    const currVal_3:boolean = !co.viewingMobileView;
    const currVal_4:any = true;
    const currVal_5:any = co.sessionModel.showExitButton;
    const currVal_6:any = ((!import0.ɵunv(v,4,4,import0.ɵnov(v,8).transform(co.viewingOrder$)) && import0.ɵunv(v,4,4,import0.ɵnov(v,9).transform(co.viewingMenuItems$)))? 'woa.heading.item-selection.title': (undefined as any));
    const currVal_7:any = ck(v,10,0,co.menuModel.getCategoryDisplayName(co.menuModel.selectedCategory));
    const currVal_8:any = 'none';
    const currVal_9:any = co.showMobileFooter;
    ck(v,4,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
    const currVal_10:any = co.showMobileNavMenuIcon;
    ck(v,14,0,currVal_10);
    const currVal_14:any = co.IconButtonType.SEARCH;
    const currVal_15:boolean = !co.isLoaded;
    const currVal_16:any = true;
    ck(v,17,0,currVal_14,currVal_15,currVal_16);
    const currVal_17:any = co.showOrderSummaryIcon;
    ck(v,20,0,currVal_17);
    const currVal_18:any = (co.loadingStatus === co.LoadingStatus.FAILED);
    ck(v,23,0,currVal_18);
    const currVal_19:any = (import0.ɵunv(v,26,0,import0.ɵnov(v,27).transform(co.viewingOrder$)) && (import0.ɵunv(v,26,0,import0.ɵnov(v,28).transform(co.OrderEvents.orderInitiationStatus$)) === co.OrderInitiationStatus.FAILED));
    ck(v,26,0,currVal_19);
    const currVal_20:any = co.showOrderingContextPanel;
    ck(v,31,0,currVal_20);
    const currVal_21:any = co.showCarousel;
    ck(v,34,0,currVal_21);
    const currVal_22:any = co.showMobileHeaderImage;
    ck(v,37,0,currVal_22);
    const currVal_23:any = import0.ɵunv(v,40,0,import0.ɵnov(v,41).transform(co.viewingOrder$));
    ck(v,40,0,currVal_23);
    const currVal_24:any = co.showFeatureButtons;
    ck(v,44,0,currVal_24);
    const currVal_25:boolean = !import0.ɵunv(v,47,0,import0.ɵnov(v,48).transform(co.viewingOrder$));
    ck(v,47,0,currVal_25);
    const currVal_26:any = import0.ɵunv(v,51,0,import0.ɵnov(v,52).transform(co.viewingOrder$));
    ck(v,51,0,currVal_26);
    ck(v,55,0);
    const currVal_27:any = co.waitTimeNotice;
    ck(v,58,0,currVal_27);
    const currVal_28:any = (co.isLoaded && co.groupOrderModel.showGroupOrderNotice);
    ck(v,61,0,currVal_28);
    const currVal_29:any = ((import0.ɵunv(v,64,0,import0.ɵnov(v,65).transform(co.viewingOrder$)) && co.orderingContextModel.showMarketingOptIn) && co.orderModel.showQuickPay(false));
    ck(v,64,0,currVal_29);
    const currVal_30:any = ((import0.ɵunv(v,68,0,import0.ɵnov(v,69).transform(co.viewingOrder$)) && co.isLoaded) && co.orderModel.hasOrderedItems());
    ck(v,68,0,currVal_30);
    const currVal_31:boolean = ((!import0.ɵunv(v,72,0,import0.ɵnov(v,73).transform(co.viewingOrder$)) && co.isLoaded) && co.orderModel.hasOrderedItems());
    ck(v,72,0,currVal_31);
    const currVal_32:any = import0.ɵunv(v,76,0,import0.ɵnov(v,77).transform(co.viewingOrder$));
    ck(v,76,0,currVal_32);
    const currVal_33:any = (import0.ɵunv(v,80,0,import0.ɵnov(v,81).transform(co.viewingOrder$)) && co.orderModel.showQuickPay(false));
    ck(v,80,0,currVal_33);
    const currVal_34:any = (import0.ɵunv(v,84,0,import0.ɵnov(v,85).transform(co.viewingOrder$)) && co.orderModel.showQuickPay(false));
    ck(v,84,0,currVal_34);
  },(ck,v) => {
    const currVal_11:any = import0.ɵnov(v,17).type;
    const currVal_12:any = import0.ɵnov(v,17).disabled;
    const currVal_13:any = import0.ɵnov(v,17).unavailable;
    ck(v,16,0,currVal_11,currVal_12,currVal_13);
  });
}
function View_OrderingPageComponent_27(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_ContentMessageComponent_0,import6.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        10,
        4
      ]
    ],1,import7.ContentMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,11,{links: 1}),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),1,1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.requestReload('failure reload',true,true,false,true)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import9.View_LinkComponent_0,import9.RenderType_LinkComponent)),
      import0.ɵdid(49152,[[
        11,
        4
      ]
      ],0,import10.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = 'woa.error.common.loadFailed';
    ck(v,1,0,currVal_8,currVal_9);
    const currVal_10:any = 'woa.button.order.reload';
    ck(v,5,0,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_28(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-promo-carousel',[
      [
        'class',
        'desktop-page-promo-carousel'
      ]
      ,
      [
        'slot',
        'content-header'
      ]

    ]
    ,(null as any),[
      [
        (null as any),
        'onOrderDeal'
      ]
      ,
      [
        (null as any),
        'onPromoActioned'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onOrderDeal' === en)) {
        const pd_0:any = ((<any>co.orderDeal($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onPromoActioned' === en)) {
        const pd_1:any = ((<any>co.promoActioned($event.promo,$event.promo.promoCardAction,$event.menuItem)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import16.View_PromoCarouselComponent_0,import16.RenderType_PromoCarouselComponent)),
      import0.ɵdid(770048,[[
        'carousel',
        4
      ]
    ],0,import17.PromoCarouselComponent,[
      import18.SessionModel,
      import19.IdentityModel,
      import20.AnalyticsService,
      import15.NavigationService,
      import0.ElementRef,
      import0.ChangeDetectorRef
    ]
    ,{
      promoteMemberLogin: [
        0,
        'promoteMemberLogin'
      ]
      ,
      deals: [
        1,
        'deals'
      ]
      ,
      promos: [
        2,
        'promos'
      ]
      ,
      morePromotionalCards: [
        3,
        'morePromotionalCards'
      ]
      ,
      showMorePromotionalCardsAsSlide: [
        4,
        'showMorePromotionalCardsAsSlide'
      ]
      ,
      nrVisibleSlides: [
        5,
        'nrVisibleSlides'
      ]
      ,
      autoScrollEnabled: [
        6,
        'autoScrollEnabled'
      ]

    }
    ,{
      onOrderDeal: 'onOrderDeal',
      onPromoActioned: 'onPromoActioned'
    }
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = true;
    const currVal_1:any = co.promotedDeals;
    const currVal_2:any = (co.orderModel.personalOrderStarted? co.triggeredAndUnsuppressedCardPromos: co.promotedCardPromos);
    const currVal_3:any = (co.orderModel.personalOrderStarted? false: co.morePromotionalCards);
    const currVal_4:any = false;
    const currVal_5:any = co.nrVisibleSlides;
    const currVal_6:boolean = !co.sessionModel.noAutoScroll;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  },(null as any));
}
function View_OrderingPageComponent_29(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-menu-category-selection-panel',[
      [
        'class',
        'desktop-page-menu-categories'
      ]
      ,
      [
        'slot',
        'content-selector'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
      ,[[
        2,
        'with-images',
        (null as any)
      ]
    ],(null as any),(null as any),import31.View_MenuCategorySelectionPanelComponent_0,import31.RenderType_MenuCategorySelectionPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import32.MenuCategorySelectionPanelComponent,[
      import33.MenuModel,
      import0.ChangeDetectorRef
    ]
      ,{showNavIcons: [
        0,
        'showNavIcons'
      ]
    },(null as any)),
    import0.ɵdid(737280,(null as any),0,import62.ResponsiveDirective,[
      import0.ElementRef,
      import14.ResponsiveService,
      import15.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    const currVal_1:any = false;
    ck(v,1,0,currVal_1);
    ck(v,2,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).withImages;
    ck(v,0,0,currVal_0);
  });
}
function View_OrderingPageComponent_30(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-menu-item-selection-panel',[
      [
        'class',
        'desktop-page-menu-items'
      ]
      ,
      [
        'slot',
        'content-details-main'
      ]

    ]
    ,(null as any),(null as any),(null as any),import36.View_MenuItemSelectionPanelComponent_0,import36.RenderType_MenuItemSelectionPanelComponent)),
    import0.ɵdid(4440064,(null as any),0,import37.MenuItemSelectionPanelComponent,[
      import33.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,{
      showBackButton: [
        0,
        'showBackButton'
      ]
      ,
      showClosePromoAction: [
        1,
        'showClosePromoAction'
      ]
      ,
      alwaysShowCategoryHeader: [
        2,
        'alwaysShowCategoryHeader'
      ]
      ,
      pageScroller: [
        3,
        'pageScroller'
      ]
      ,
      anchorPanel: [
        4,
        'anchorPanel'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = false;
    const currVal_1:any = true;
    const currVal_2:any = true;
    const currVal_3:any = ((import0.ɵnov((<any>v.parent),6) == null)? (null as any): import0.ɵnov((<any>v.parent),6).scrollerER);
    const currVal_4:any = co.anchorPanelER;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
  },(null as any));
}
function View_OrderingPageComponent_31(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-ordering-context-panel',[[
        'slot',
        'sidebar-header'
      ]
    ],(null as any),(null as any),(null as any),import11.View_OrderingContextPanelComponent_0,import11.RenderType_OrderingContextPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import12.OrderingContextPanelComponent,[
      import13.OrderingContextModel,
      import5.OrderModel,
      import14.ResponsiveService,
      import15.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
function View_OrderingPageComponent_32(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-feature-button-panel',[
      [
        'class',
        'desktop-page-feature-buttons'
      ]
      ,
      [
        'slot',
        'sidebar-body'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'onOpenGroupOrder'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onOpenGroupOrder' === en)) {
        const pd_0:any = ((<any>co.groupOrderModel.openGroupOrder()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import25.View_FeatureButtonPanelComponent_0,import25.RenderType_FeatureButtonPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import27.FeatureButtonPanelComponent,[
      import18.SessionModel,
      import13.OrderingContextModel,
      import19.IdentityModel,
      import28.GroupOrderModel,
      import29.DealModel,
      import15.NavigationService,
      import30.SessionController,
      import0.ChangeDetectorRef,
      import20.AnalyticsService
    ]
    ,(null as any),{onOpenGroupOrder: 'onOpenGroupOrder'})
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
function View_OrderingPageComponent_33(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-footer-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_FooterMessageComponent_0,import6.RenderType_FooterMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.FooterMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      icon: [
        1,
        'icon'
      ]
      ,
      text: [
        2,
        'text'
      ]
      ,
      translationParams: [
        3,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,12,{links: 1}),
    import0.ɵpod([
      'category',
      'venueWaitTime',
      'categoryWaitTime'
    ]
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.WARNING;
    const currVal_9:any = 'clock-three';
    const currVal_10:any = co.waitTimeNotice;
    const currVal_11:any = ck(v,3,0,co.menuModel.getCategoryDisplayName(co.menuModel.selectedCategory),co.orderingContextModel.venueWaitTime,co.menuModel.selectedCategoryWaitTime);
    ck(v,1,0,currVal_8,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_34(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-footer-message',[[
        'class',
        'group-order-notice'
      ]
    ],[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.groupOrderModel.openGroupOrder()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import6.View_FooterMessageComponent_0,import6.RenderType_FooterMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.FooterMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      showIcon: [
        2,
        'showIcon'
      ]
      ,
      actionable: [
        3,
        'actionable'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,13,{links: 1}),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'woa-group-order-summary-icon',([] as any[]),(null as any),(null as any),(null as any),import42.View_GroupOrderSummaryIconComponent_0,import42.RenderType_GroupOrderSummaryIconComponent)),
    import0.ɵdid(180224,(null as any),0,import43.GroupOrderSummaryIconComponent,[
      import5.OrderModel,
      import28.GroupOrderModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.SUCCESS;
    const currVal_9:any = 'woa.message.order.groupOrderNotice';
    const currVal_10:any = false;
    const currVal_11:any = true;
    ck(v,1,0,currVal_8,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_35(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-totals-panel',[
      [
        'class',
        'totals'
      ]
      ,
      [
        'slot',
        'sidebar-footer-start'
      ]

    ]
    ,(null as any),(null as any),(null as any),import46.View_OrderTotalsPanelComponent_0,import46.RenderType_OrderTotalsPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import47.OrderTotalsPanelComponent,[
      import13.OrderingContextModel,
      import5.OrderModel,
      import15.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
function View_OrderingPageComponent_36(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.checkout()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import48.View_ButtonComponent_0,import48.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import49.ButtonComponent,[
      import0.ElementRef,
      import18.SessionModel,
      import0.ChangeDetectorRef,
      import14.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      showSpinner: [
        1,
        'showSpinner'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]
      ,
      prominence: [
        3,
        'prominence'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵdid(16384,(null as any),0,import50.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = co.otherPayLabel;
    const currVal_28:any = co.checkoutPending;
    const currVal_29:any = (co.checkoutPending || (import0.ɵunv(v,1,2,import0.ɵnov(v,2).transform(co.OrderEvents.orderInitiationStatus$)) === co.OrderInitiationStatus.INITIATING));
    const currVal_30:any = co.otherPayProminence;
    ck(v,1,0,currVal_27,currVal_28,currVal_29,currVal_30);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderingPageComponent_37(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-quick-pay-panel',[[
        'woa-page-footer-control',
        ''
      ]
      ],(null as any),[[
        (null as any),
        'pay'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pay' === en)) {
        const pd_0:any = ((<any>co.quickPay(false,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import51.View_QuickPayPanelComponent_0,import51.RenderType_QuickPayPanelComponent)),
    import0.ɵdid(16384,(null as any),0,import50.PageFooterControlDirective,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(49152,(null as any),0,import52.QuickPayPanelComponent,[
      import5.OrderModel,
      import53.PaymentModel,
      import18.SessionModel,
      import28.GroupOrderModel
    ]
    ,{
      requireLogin: [
        0,
        'requireLogin'
      ]
      ,
      showSpinner: [
        1,
        'showSpinner'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]

    }
    ,{pay: 'pay'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = false;
    const currVal_1:any = co.checkoutPending;
    const currVal_2:any = co.checkoutPending;
    ck(v,2,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
function View_OrderingPageComponent_38(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-legal-panel',[
      [
        'class',
        'desktop-page-payment-legal'
      ]
      ,
      [
        'slot',
        'sidebar-footer-end'
      ]

    ]
    ,(null as any),(null as any),(null as any),import54.View_LegalPanelComponent_0,import54.RenderType_LegalPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import55.LegalPanelComponent,[
      import20.AnalyticsService,
      import15.NavigationService
    ]
      ,{messageSet: [
        0,
        'messageSet'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'payment';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingPageComponent_26(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),59,'woa-desktop-home-page-layout',[[
        'class',
        'desktop-page'
      ]
    ],(null as any),[
      [
        (null as any),
        'onRefresh'
      ]
      ,
      [
        (null as any),
        'onSearchMenu'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onRefresh' === en)) {
        const pd_0:any = ((<any>co.requestReload('user refresh',true,true,true,true)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onSearchMenu' === en)) {
        const pd_1:any = ((<any>co.searchMenu()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import63.View_DesktopHomePageLayoutComponent_0,import63.RenderType_DesktopHomePageLayoutComponent)),
    import0.ɵdid(16384,(null as any),0,import64.BackgroundImageDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import65.CachedImageService
    ]
      ,{imageSpecs: [
        0,
        'imageSpecs'
      ]
    },(null as any)),
    import0.ɵpod(['--woa-desktop-menu-image-applied']),
    import0.ɵpod([
      'conditional',
      'on',
      'image',
      'opacity',
      'tiled',
      'classes',
      'cssVars'
    ]
    ),
    import0.ɵpod([
      'classes',
      'conditional'
    ]
    ),
    import0.ɵpad(2),
    import0.ɵdid(245760,[
      [
        3,
        4
      ]
      ,
      [
        'desktopHomePage',
        4
      ]

    ]
    ,1,import66.DesktopHomePageLayoutComponent,[
      import58.Page,
      import18.SessionModel,
      import15.NavigationService,
      import13.OrderingContextModel,
      import0.ChangeDetectorRef,
      import14.ResponsiveService
    ]
      ,{enableNavMenuIcon: [
        0,
        'enableNavMenuIcon'
      ]
    },{
      onRefresh: 'onRefresh',
      onSearchMenu: 'onSearchMenu'
    }
    ),
    import0.ɵqud(603979776,10,{contentMessages: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import58.PageLayout,(null as any),[import66.DesktopHomePageLayoutComponent]),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderingPageComponent_27)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),1,1,(null as any),View_OrderingPageComponent_28)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),2,1,(null as any),View_OrderingPageComponent_29)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,[[
        2,
        0
      ]
    ],3,1,'woa-menu-subcategory-anchor-panel',[
      [
        'class',
        'desktop-page-menu-subcategory-anchors'
      ]
      ,
      [
        'slot',
        'content-details-header'
      ]

    ]
    ,(null as any),(null as any),(null as any),import34.View_MenuSubcategoryAnchorPanelComponent_0,import34.RenderType_MenuSubcategoryAnchorPanelComponent)),
      import0.ɵdid(4440064,[[
        'anchorPanel',
        4
      ]
    ],0,import35.MenuSubcategoryAnchorPanelComponent,[
      import33.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingPageComponent_30)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),5,1,(null as any),View_OrderingPageComponent_31)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),6,1,'woa-order-heading-panel',[
      [
        'class',
        'desktop-page-order-heading'
      ]
      ,
      [
        'slot',
        'sidebar-body'
      ]

    ]
    ,(null as any),(null as any),(null as any),import23.View_OrderHeadingPanelComponent_0,import23.RenderType_OrderHeadingPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import24.OrderHeadingPanelComponent,[
      import13.OrderingContextModel,
      import15.NavigationService
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),6,1,(null as any),View_OrderingPageComponent_32)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),6,1,'woa-order-edit-panel',[
      [
        'class',
        'desktop-page-order'
      ]
      ,
      [
        'slot',
        'sidebar-body'
      ]

    ]
    ,(null as any),[
      [
        (null as any),
        'onRetry'
      ]
      ,
      [
        (null as any),
        'onEditOrderItem'
      ]
      ,
      [
        (null as any),
        'onRemoveOrderItem'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onRetry' === en)) {
        const pd_0:any = ((<any>co.orderModel.requestOrderInitiation('ordering page - initiation error retry')) !== false);
        ad = (pd_0 && ad);
      }
      if (('onEditOrderItem' === en)) {
        const pd_1:any = ((<any>co.orderModel.editOrderItem($event)) !== false);
        ad = (pd_1 && ad);
      }
      if (('onRemoveOrderItem' === en)) {
        const pd_2:any = ((<any>co.orderModel.removeOrderItem($event)) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },import40.View_OrderEditPanelComponent_0,import40.RenderType_OrderEditPanelComponent)),
    import0.ɵdid(4374528,(null as any),0,import41.OrderEditPanelComponent,[
      import13.OrderingContextModel,
      import5.OrderModel,
      import33.MenuModel,
      import30.SessionController,
      import15.NavigationService,
      import0.ChangeDetectorRef,
      import8.NotificationService,
      import20.AnalyticsService
    ]
    ,(null as any),{
      onRetry: 'onRetry',
      onEditOrderItem: 'onEditOrderItem',
      onRemoveOrderItem: 'onRemoveOrderItem'
    }
    ),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),7,1,'woa-order-errors-panel',[[
        'slot',
        'footer-messages'
      ]
    ],(null as any),(null as any),(null as any),import60.View_OrderErrorsPanelComponent_0,import60.RenderType_OrderErrorsPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import61.OrderErrorsPanelComponent,[
      import5.OrderModel,
      import13.OrderingContextModel,
      import18.SessionModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_OrderingPageComponent_33)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_OrderingPageComponent_34)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,1,(null as any),View_OrderingPageComponent_35)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),9,1,(null as any),View_OrderingPageComponent_36)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),9,1,(null as any),View_OrderingPageComponent_37)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),10,1,(null as any),View_OrderingPageComponent_38)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,5,0,ck(v,3,0,true,!co.menuModel.showItemImages,co.menuModel.pageImage,co.menuModel.pageImageOpacity,true,'menu-page-image-color-pair',ck(v,2,0,true)),ck(v,4,0,'theme-standard-page-color-pair',false));
    ck(v,1,0,currVal_0);
    const currVal_1:any = ((co.loadingStatus === co.LoadingStatus.LOADED) || (co.loadingStatus === co.LoadingStatus.RELOADING));
    ck(v,6,0,currVal_1);
    const currVal_2:any = (co.loadingStatus === co.LoadingStatus.FAILED);
    ck(v,11,0,currVal_2);
    const currVal_3:any = co.showCarousel;
    ck(v,15,0,currVal_3);
    const currVal_4:any = co.showMenu;
    ck(v,18,0,currVal_4);
    ck(v,22,0);
    const currVal_5:any = co.showMenu;
    ck(v,25,0,currVal_5);
    const currVal_6:any = co.showOrderingContextPanel;
    ck(v,28,0,currVal_6);
    const currVal_7:any = co.showFeatureButtons;
    ck(v,34,0,currVal_7);
    ck(v,40,0);
    const currVal_8:any = co.waitTimeNotice;
    ck(v,43,0,currVal_8);
    const currVal_9:any = (co.isLoaded && co.groupOrderModel.showGroupOrderNotice);
    ck(v,46,0,currVal_9);
    const currVal_10:any = (co.isLoaded && co.orderModel.hasOrderedItems());
    ck(v,49,0,currVal_10);
    const currVal_11:any = (co.isLoaded && co.orderModel.hasOrderedItems());
    ck(v,52,0,currVal_11);
    const currVal_12:any = (((co.isLoaded && co.orderModel.hasOrderedItems()) && !co.suppressQuickPay) && co.orderModel.showQuickPay(false));
    ck(v,55,0,currVal_12);
    const currVal_13:any = ((co.isLoaded && co.orderModel.hasOrderedItems()) && co.orderModel.showQuickPay(false));
    ck(v,58,0,currVal_13);
  },(null as any));
}
export function View_OrderingPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
    import0.ɵqud(671088640,1,{pageLayout: 0}),
    import0.ɵqud(671088640,2,{anchorPanelER: 0}),
    import0.ɵqud(671088640,3,{desktopHomePage: 0}),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingPageComponent_26)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import67.OrderingPageComponent = v.component;
    const currVal_0:any = co.responsiveService.mobile;
    ck(v,4,0,currVal_0);
    const currVal_1:any = co.responsiveService.desktop;
    ck(v,7,0,currVal_1);
  },(null as any));
}
function View_OrderingPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-ordering-page',([] as any[]),(null as any),(null as any),(null as any),View_OrderingPageComponent_0,RenderType_OrderingPageComponent)),
    import0.ɵdid(245760,(null as any),0,import67.OrderingPageComponent,[
      import8.NotificationService,
      import20.AnalyticsService,
      import68.LoadingService,
      import0.ChangeDetectorRef,
      import0.ElementRef,
      import69.AuthService,
      import29.DealModel,
      import53.PaymentModel,
      import19.IdentityModel,
      import70.ActiveSchedulesSearchModel,
      import18.SessionModel,
      import13.OrderingContextModel,
      import5.OrderModel,
      import33.MenuModel,
      import71.PromoModel,
      import28.GroupOrderModel,
      import15.NavigationService,
      import30.SessionController,
      import14.ResponsiveService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import58.Page,(null as any),[import67.OrderingPageComponent])
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const OrderingPageComponentNgFactory:import0.ComponentFactory<import67.OrderingPageComponent> = import0.ɵccf('woa-ordering-page',import67.OrderingPageComponent,View_OrderingPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/ordering-page/ordering-page.component.ngfactory.ts